import React, { createContext, useContext, useReducer } from 'react';
import { StatsState, statsReducer, initialStatsState } from '../store/statsSlice';
interface StatsContextType {
  state: StatsState;
  dispatch: React.Dispatch<any>;
}
const StatsContext = createContext<StatsContextType | undefined>(undefined);
export const StatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(statsReducer, initialStatsState);

  return (
    <StatsContext.Provider value={{ state, dispatch }}>
      {children}
    </StatsContext.Provider>
  );
};

export const useStats = () => {
  const context = useContext(StatsContext);
  if (context === undefined) {
    throw new Error('useStats must be used within a StatsProvider');
  }
  return context;
};
